var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 0.002,
    style: {
      fill: "#FFFFFF"
    },
    width: 425.197,
    height: 425.196
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#B2B2B2"
    },
    cx: 165.301,
    cy: 368.09,
    rx: 96.824,
    ry: 22.568
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D3953"
    },
    d: "M318.1,353.492c-0.018,3.305-2.713,5.977-6.022,5.957l-114.348-0.615 c-3.309-0.018-5.975-2.717-5.957-6.022l0.834-155.189c0.02-3.305,2.715-5.975,6.023-5.957l114.348,0.615 c3.309,0.02,5.973,2.717,5.955,6.021L318.1,353.492z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.803,344.615c-0.014,2.768-2.27,4.998-5.035,4.982l-95.623-0.514 c-2.766-0.016-4.994-2.27-4.98-5.037l0.738-137c0.016-2.768,2.27-4.998,5.033-4.982l95.625,0.516 c2.764,0.014,4.994,2.27,4.98,5.035L307.803,344.615z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M300.166,220.621c-0.006,0.703-0.576,1.268-1.281,1.264l-86.48-0.465 c-0.701-0.004-1.271-0.576-1.268-1.279l0,0c0.004-0.701,0.58-1.268,1.281-1.264l86.48,0.465 C299.603,219.346,300.168,219.918,300.166,220.621L300.166,220.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M300.096,233.521c-0.004,0.701-0.574,1.268-1.279,1.266l-86.482-0.467 c-0.701-0.004-1.27-0.576-1.266-1.277l0,0c0.002-0.705,0.578-1.271,1.279-1.267l86.483,0.465 C299.535,232.244,300.1,232.818,300.096,233.521L300.096,233.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M300.025,246.422c-0.002,0.701-0.574,1.268-1.279,1.266l-86.48-0.467 c-0.701-0.004-1.271-0.576-1.268-1.277l0,0c0.004-0.705,0.58-1.27,1.281-1.266l86.48,0.465 C299.465,245.146,300.029,245.717,300.025,246.422L300.025,246.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M299.957,259.322c-0.004,0.701-0.576,1.268-1.279,1.266l-86.482-0.465 c-0.701-0.006-1.27-0.578-1.268-1.279l0,0c0.004-0.701,0.58-1.27,1.281-1.266l86.482,0.465 C299.395,258.047,299.959,258.621,299.957,259.322L299.957,259.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M299.887,272.223c-0.004,0.701-0.574,1.27-1.279,1.266l-86.482-0.465 c-0.701-0.004-1.27-0.578-1.266-1.279l0,0c0.002-0.703,0.578-1.268,1.279-1.264l86.482,0.465 C299.326,270.949,299.891,271.522,299.887,272.223L299.887,272.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M299.816,285.123c-0.004,0.703-0.574,1.268-1.279,1.264l-86.481-0.465 c-0.701-0.004-1.271-0.576-1.268-1.277l0,0c0.004-0.701,0.58-1.268,1.281-1.264l86.481,0.465 C299.256,283.85,299.82,284.42,299.816,285.123L299.816,285.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M299.748,298.023c-0.004,0.703-0.574,1.27-1.279,1.266l-86.482-0.465 c-0.701-0.006-1.27-0.578-1.266-1.281l0,0c0.004-0.703,0.578-1.27,1.279-1.266l86.482,0.467 C299.188,296.748,299.752,297.32,299.748,298.023L299.748,298.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M299.678,310.926c-0.004,0.701-0.572,1.266-1.279,1.262l-86.48-0.467 c-0.703-0.004-1.271-0.574-1.268-1.275l0,0c0.004-0.701,0.578-1.268,1.281-1.266l86.481,0.467 C299.119,309.65,299.684,310.225,299.678,310.926L299.678,310.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M299.609,323.824c-0.004,0.703-0.574,1.272-1.279,1.266l-86.481-0.465 c-0.703-0.004-1.271-0.576-1.268-1.281l0,0c0.004-0.701,0.578-1.266,1.281-1.262l86.48,0.465 C299.049,322.553,299.613,323.121,299.609,323.824L299.609,323.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M299.539,336.727c-0.004,0.701-0.574,1.266-1.279,1.264l-86.48-0.467 c-0.701-0.004-1.271-0.574-1.268-1.275l0,0c0.004-0.705,0.58-1.27,1.281-1.266l86.48,0.467 C298.978,335.453,299.543,336.023,299.539,336.727L299.539,336.727z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E74645"
    },
    d: "M293.844,206.52c-0.017,3.309-2.715,5.975-6.021,5.957l-64.254-0.346 c-3.311-0.018-5.977-2.715-5.957-6.023l0.111-20.691c0.018-3.307,2.711-5.975,6.021-5.957l64.254,0.346 c3.309,0.02,5.975,2.715,5.957,6.023L293.844,206.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M276.17,201.947c-6.541,1.057-13.008,0.982-19.475-0.613c-5.879-1.445-12.434-4.336-16.371-9.148 c-3.252-3.979-4.902-8.266-5.369-12.666l-11.211-0.061c-3.311-0.018-6.004,2.65-6.021,5.957l-0.111,20.691 c-0.02,3.309,2.646,6.006,5.957,6.023l64.254,0.346c3.307,0.018,6.004-2.648,6.021-5.957l0.066-12.25 C288.828,198.133,282.881,200.865,276.17,201.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E74645"
    },
    d: "M255.984,158.395c-10.525-0.055-19.104,8.432-19.158,18.961 c-0.059,10.522,8.428,19.104,18.953,19.158c10.525,0.059,19.105-8.432,19.162-18.955 C274.998,167.033,266.508,158.453,255.984,158.395z M255.844,184.533c-4.809-0.027-8.689-3.947-8.664-8.756 c0.025-4.814,3.949-8.693,8.758-8.668c4.813,0.025,8.693,3.945,8.666,8.76C264.578,180.682,260.656,184.559,255.844,184.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.07,182.898c-0.004,0.498-0.412,0.904-0.912,0.9l-48.1-0.258 c-0.502-0.004-0.906-0.412-0.904-0.912l0,0c0.004-0.502,0.414-0.906,0.912-0.904l48.102,0.26 C288.668,181.986,289.072,182.395,289.07,182.898L289.07,182.898z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C343F",
      strokeWidth: 2.4769,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M225.502,236.256l0.02-4.08c0,0-0.164-3.098-3.07-4.979c0,0-8.83-5.217-9.055-24.709c0,0-0.512-27.102-35.168-27.289 l-16.146-0.086"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C343F",
      strokeWidth: 2.4769,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M105.234,235.607l0.023-4.078c0,0,0.197-3.1,3.125-4.943c0,0,8.881-5.123,9.316-24.615c0,0,0.807-27.094,35.463-26.906 l16.146,0.088"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7C7AD"
    },
    d: "M209.535,304.352c-17.66-2.09-26.332-7.359-27.818-8.34l-31.467-0.17 c-1.496,0.965-10.227,6.141-27.91,8.041c0,0-33.689,1.076-33.074,62.148c0,0,25.285,11.57,76.275,11.748 c50.99,0.371,76.398-10.926,76.398-10.926C243.215,305.791,209.535,304.352,209.535,304.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.34,303.883c0,0-33.689,1.076-33.074,62.148c0,0,25.285,11.57,76.275,11.748 c50.99,0.371,76.398-10.926,76.398-10.926c1.275-61.063-32.404-62.502-32.404-62.502s-32.785-2.508-43.658,11.4 C165.877,315.752,155.561,298.52,122.34,303.883z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 154.326,
    y: 274.566,
    transform: "matrix(0.0055 -1 1 0.0055 -125.5269 455.05)",
    style: {
      fill: "#F7C7AD"
    },
    width: 23.368,
    height: 32.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M149.971,285.523v0.004c0.354,0.422,0.709,0.84,1.088,1.236c1,1.041,2.035,2.045,3.152,2.959 c0.037,0.031,0.064,0.049,0.102,0.082c0.357,0.264,0.725,0.525,1.094,0.779c0.568,0.383,1.137,0.771,1.727,1.123 c0.854,0.512,1.719,1.01,2.609,1.455c0.285,0.111,1.125,0.465,1.385,0.555c0.863,0.297,1.725,0.594,2.607,0.828 c0.906,0.244,1.816,0.488,2.736,0.668c-0.24-0.049,2.428,0.41,1.787,0.352c2.164,0.254,4.344,0.428,6.52,0.4 c0.938-0.016,1.873-0.027,2.803-0.098c0.299-0.023,1.695-0.223,1.836-0.221c0.891-0.188,1.77-0.432,2.639-0.711l0.084-15.9 l-32.133-0.172l-0.035,6.59C150.063,285.596,150.082,285.645,149.971,285.523z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7C7AD"
    },
    d: "M202.857,236.9c-0.146,27.676-16.637,50.021-36.824,49.914 c-20.191-0.107-36.438-22.633-36.289-50.307c0.148-27.678,16.609-44.936,36.799-44.828 C186.732,191.789,203.01,209.225,202.857,236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M146.936,213.99c0.01-0.066,0.027-0.131,0.033-0.195 c5.199-6.037,12.348-9.373,20.217-9.332c15.771,0.086,28.488,13.705,28.369,35.328c-0.076,14.408-5.828,26.963-14.322,33.715 C181.232,273.506,133.463,267.549,146.936,213.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEDED"
    },
    d: "M160.396,275.76c-12.41-7.914-19.129-21.277-20.777-35.625 c-1.547-13.479,1.963-28.361,10.564-38.967c2.986-3.678,6.793-6.789,11.01-9.098c-17.668,2.697-31.313,19.248-31.449,44.438 c-0.148,27.674,16.098,50.199,36.289,50.307c5.863,0.031,11.416-1.836,16.344-5.172 C174.727,281.859,167.07,280.02,160.396,275.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D3953"
    },
    d: "M148.703,296.74c-3.422,1.836-11.9,5.586-26.363,7.143c0,0-33.689,1.076-33.074,62.148 c0,0,25.285,11.57,76.275,11.748c50.99,0.371,76.398-10.926,76.398-10.926c1.275-61.063-32.404-62.502-32.404-62.502 c-14.451-1.713-22.887-5.551-26.287-7.428c0,0,17.744,40.117-17.68,75.947C165.568,372.871,131.707,337.598,148.703,296.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B1C3"
    },
    d: "M137.807,325.717c0.016,0.08,0.027,0.16,0.041,0.238c0.125,0.627,0.256,1.248,0.391,1.871 c0.094-0.039,0.184-0.082,0.281-0.119C138.27,327.055,138.033,326.389,137.807,325.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#031B2B"
    },
    d: "M209.535,304.352c-14.451-1.713-22.887-5.551-26.287-7.428c0,0,2.402,18.934-17.68,75.947 c0,0-16.943-48.465-16.865-76.131c-3.422,1.836-11.9,5.586-26.363,7.143c0,0-1.207,11.629,6.055,27.564 c0,0,5.117-2.719,7.863-1.92l-7.971,5.787c0,0,12.34,20.695,30.48,42.43l15.309,0.082c0,0,20.893-28.957,31.021-46.355 c0,0-2.428-2.772-9.938-5.16c0,0,4.627-1.543,9.969-0.73C205.129,325.58,211.031,315.994,209.535,304.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B1C3"
    },
    d: "M165.541,377.779"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE1622"
    },
    d: "M165.568,372.871c-8.447-24.389-8.824-29.396-8.824-29.396l3.51-17.637l9.797,0.303l4.814,17.828 C174.865,343.969,168.035,367.142,165.568,372.871z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE1622"
    },
    d: "M157.617,315.709l15.678,0.084c0,0,0.646,8.385-5.426,12.191l-5.779-0.029 C162.09,327.955,155.797,322.084,157.617,315.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M173.295,315.793l-2.793-0.018c0.223,0.586,0.348,1.217,0.346,1.871 c-0.016,2.896-2.445,5.297-5.338,5.279h-0.09c-2.895-0.016-5.295-2.441-5.279-5.336c0.004-0.656,0.135-1.283,0.365-1.867 l-2.889-0.014c-1.82,6.375,4.473,12.246,4.473,12.246l5.779,0.029C173.941,324.178,173.295,315.793,173.295,315.793z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#432918"
    },
    d: "M166.795,202.332c0,0,32.309-18.992,35.086,45.771c0,0,11.438-31.582-8.377-55.859 c0,0-20.793-22.537-53.717-2.533c0,0-6.832,4.088-12.668,2.176c0,0,2.978,5.477,7.533,6.604c0,0-5.455,4.004-11.824,2.686 c0,0,2.936,7.715,7.059,8.75c0,0-8.332,14.379,0.715,37.795C130.602,247.721,130.68,185.627,166.795,202.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M200.93,213.08c0,0-0.109-0.314-0.316-0.908c-0.211-0.596-0.494-1.477-0.939-2.559 c-0.402-1.094-0.998-2.383-1.672-3.852c-0.371-0.719-0.77-1.486-1.189-2.285c-0.473-0.777-0.912-1.623-1.451-2.457 c-0.563-0.814-1.086-1.707-1.754-2.533c-0.318-0.428-0.645-0.861-0.977-1.301c-0.352-0.418-0.711-0.84-1.082-1.27 c-0.18-0.211-0.367-0.43-0.549-0.646c-0.199-0.203-0.402-0.408-0.604-0.615c-0.408-0.408-0.809-0.832-1.232-1.244 c-0.895-0.762-1.752-1.604-2.752-2.307c-0.939-0.777-2.018-1.393-3.061-2.074c-1.117-0.564-2.213-1.197-3.4-1.65l-0.877-0.369 c-0.291-0.135-0.605-0.203-0.906-0.307c-0.611-0.188-1.215-0.402-1.834-0.566c-0.631-0.139-1.262-0.271-1.889-0.406 l-0.469-0.101l-0.479-0.072c-0.326-0.043-0.67-0.104-0.986-0.139c-1.256-0.164-2.574-0.25-3.861-0.285 c-1.289-0.006-2.572,0.037-3.824,0.197c-0.313,0.029-0.617,0.1-0.926,0.145l-0.459,0.074l-0.465,0.1 c-0.633,0.137-1.281,0.26-1.898,0.404c-0.615,0.15-1.225,0.299-1.828,0.449c-0.6,0.174-1.199,0.344-1.791,0.514 c-2.359,0.725-4.598,1.555-6.662,2.49c-0.51,0.246-1.014,0.488-1.51,0.727c-0.496,0.234-0.957,0.518-1.434,0.76 c-0.945,0.488-1.842,1.041-2.727,1.527c-1.756,1.01-3.463,1.836-5.061,2.35c-1.592,0.537-3.098,0.674-4.297,0.547 c-0.299-0.051-0.58-0.068-0.844-0.135c-0.254-0.074-0.496-0.145-0.721-0.213c-0.432-0.164-0.789-0.332-1.07-0.477 c-0.531-0.34-0.816-0.518-0.816-0.518s0.303,0.143,0.867,0.412c0.293,0.104,0.658,0.225,1.092,0.332 c0.221,0.035,0.459,0.074,0.711,0.113c0.252,0.041,0.527,0.025,0.809,0.047c1.141,0.004,2.514-0.273,3.979-0.898 c1.469-0.619,3.029-1.541,4.695-2.637c1.654-1.104,3.516-2.346,5.604-3.414c2.088-1.068,4.367-2.055,6.795-2.861 c0.611-0.193,1.225-0.391,1.844-0.586c0.631-0.174,1.266-0.35,1.904-0.529c0.635-0.162,1.264-0.307,1.902-0.463l0.498-0.107 l0.51-0.092c0.34-0.059,0.68-0.133,1.023-0.168c1.367-0.188,2.746-0.25,4.127-0.254c1.381,0.023,2.748,0.096,4.148,0.273 c0.346,0.041,0.666,0.104,1.002,0.148l0.516,0.084l0.508,0.113c0.68,0.152,1.359,0.309,2.035,0.459 c0.668,0.184,1.318,0.42,1.979,0.627c0.322,0.117,0.66,0.197,0.975,0.342l0.941,0.408c1.279,0.496,2.445,1.203,3.617,1.852 c1.102,0.756,2.229,1.457,3.207,2.305c1.035,0.783,1.93,1.688,2.828,2.547c0.428,0.451,0.826,0.918,1.232,1.365 c0.201,0.227,0.4,0.453,0.598,0.674c0.184,0.236,0.367,0.473,0.547,0.703c0.361,0.467,0.715,0.924,1.063,1.379 c0.318,0.473,0.631,0.941,0.938,1.398c0.635,0.908,1.117,1.859,1.635,2.74c0.492,0.891,0.9,1.781,1.314,2.611 c0.365,0.85,0.695,1.668,1.01,2.428c0.287,0.777,0.535,1.504,0.768,2.178c0.238,0.67,0.383,1.316,0.551,1.883 c0.348,1.127,0.496,2.039,0.641,2.654C200.857,212.754,200.93,213.08,200.93,213.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M196.627,214.938c0,0-0.096-0.285-0.273-0.818c-0.188-0.535-0.43-1.33-0.818-2.305 c-0.191-0.486-0.379-1.033-0.631-1.611c-0.254-0.578-0.525-1.199-0.816-1.869c-0.324-0.652-0.666-1.342-1.031-2.072 c-0.396-0.707-0.811-1.457-1.252-2.227c-0.953-1.502-2.006-3.115-3.313-4.662c-0.619-0.801-1.354-1.531-2.078-2.303 c-0.369-0.379-0.779-0.717-1.168-1.09c-0.197-0.184-0.395-0.369-0.592-0.555c-0.213-0.166-0.426-0.336-0.637-0.506 c-1.672-1.412-3.629-2.561-5.689-3.51l-0.783-0.342c-0.262-0.117-0.518-0.236-0.795-0.313c-0.545-0.182-1.088-0.357-1.633-0.537 c-0.555-0.16-1.125-0.26-1.684-0.393c-0.275-0.057-0.574-0.139-0.828-0.18l-0.895-0.133c-2.27-0.316-4.641-0.414-6.879-0.143 c-0.283,0.025-0.557,0.072-0.83,0.125l-0.41,0.07l-0.189,0.031l-0.217,0.047c-0.572,0.127-1.143,0.25-1.709,0.375 c-0.547,0.139-1.092,0.279-1.633,0.416c-0.535,0.141-1.07,0.316-1.598,0.473c-2.111,0.666-4.111,1.43-5.953,2.289 c-1.832,0.879-3.469,1.848-5.035,2.779c-1.563,0.932-3.076,1.701-4.504,2.188c-1.416,0.508-2.771,0.648-3.846,0.533 c-1.094-0.09-1.863-0.502-2.363-0.754c-0.473-0.316-0.725-0.48-0.725-0.48s0.268,0.133,0.771,0.381 c0.264,0.098,0.592,0.215,0.975,0.309c0.197,0.035,0.41,0.068,0.637,0.109c0.225,0.031,0.471,0.023,0.725,0.041 c1.021,0.002,2.248-0.266,3.553-0.848c1.307-0.576,2.688-1.436,4.162-2.439c1.469-1.023,3.131-2.154,4.984-3.143 c1.861-0.982,3.896-1.893,6.072-2.627c0.547-0.182,1.088-0.375,1.652-0.541c0.564-0.16,1.133-0.324,1.703-0.486 c0.566-0.141,1.131-0.283,1.697-0.424l0.221-0.051l0.244-0.047l0.453-0.084c0.309-0.057,0.615-0.115,0.924-0.143 c2.463-0.318,4.936-0.248,7.426,0.082l0.891,0.143c0.338,0.053,0.617,0.137,0.93,0.203c0.605,0.152,1.217,0.268,1.818,0.445 c0.588,0.201,1.178,0.4,1.764,0.602c0.297,0.086,0.58,0.217,0.863,0.342l0.84,0.383c2.23,1.031,4.27,2.369,6.01,3.908 c0.223,0.189,0.441,0.375,0.662,0.561c0.203,0.203,0.406,0.402,0.615,0.602c0.4,0.402,0.813,0.783,1.184,1.203 c0.723,0.846,1.455,1.652,2.059,2.52c1.301,1.672,2.273,3.414,3.139,5.021c0.404,0.822,0.785,1.611,1.123,2.367 c0.309,0.773,0.598,1.504,0.869,2.191c0.236,0.701,0.453,1.359,0.656,1.967c0.193,0.607,0.326,1.186,0.471,1.691 c0.299,1.018,0.418,1.838,0.543,2.387C196.568,214.643,196.627,214.938,196.627,214.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M128.238,202.525c0.184,0.377,0.395,0.734,0.639,1.064c0.119,0.17,0.254,0.326,0.375,0.484 c0.139,0.148,0.271,0.305,0.412,0.445c0.152,0.135,0.295,0.273,0.447,0.404l0.475,0.357l0.502,0.307 c0.17,0.092,0.35,0.164,0.527,0.248c0.17,0.088,0.365,0.131,0.543,0.191c0.184,0.059,0.365,0.121,0.557,0.145l0.564,0.104 l0.574,0.035l0.287,0.014l0.289-0.023l0.572-0.039c0.193-0.016,0.385-0.068,0.576-0.096l0.572-0.098l3.818-0.652l-3.387,2.039 c-0.188,0.115-0.48,0.348-0.717,0.553c-0.229,0.246-0.484,0.453-0.688,0.732c-0.443,0.506-0.828,1.078-1.193,1.66l-0.502,0.906 c-0.17,0.303-0.285,0.639-0.43,0.953c-0.295,0.629-0.518,1.303-0.744,1.971c-0.256,0.65-0.396,1.358-0.572,2.041 c-0.082,0.346-0.188,0.684-0.246,1.037c-0.059,0.35-0.117,0.703-0.184,1.057c-0.121,0.701-0.283,1.4-0.332,2.121l-0.23,2.146 c-0.057,0.717-0.082,1.441-0.129,2.16c-0.027,0.723-0.111,1.445-0.084,2.174c0.008,0.725-0.01,1.453-0.016,2.184l-0.008,1.09 c-0.004,0.367,0.031,0.73,0.037,1.094l0.066,2.195c0.029,0.73,0.018,1.469,0.082,2.199c0.104,1.463,0.168,2.934,0.207,4.42 c-0.367-1.432-0.705-2.873-1.01-4.324c-0.174-0.723-0.281-1.455-0.383-2.189l-0.324-2.203c-0.119-0.734-0.17-1.475-0.221-2.217 c-0.055-0.744-0.115-1.486-0.156-2.227c-0.068-0.744-0.021-1.496-0.029-2.244c0.012-0.746-0.012-1.496,0.029-2.244l0.201-2.248 c0.043-0.752,0.197-1.494,0.314-2.242c0.059-0.375,0.127-0.748,0.197-1.115c0.066-0.373,0.184-0.74,0.279-1.107 c0.203-0.732,0.365-1.477,0.656-2.191l0.393-1.082c0.125-0.363,0.33-0.699,0.486-1.047c0.18-0.346,0.326-0.703,0.531-1.033 l0.619-0.996c0.447-0.639,0.916-1.275,1.49-1.83c0.266-0.293,0.602-0.535,0.902-0.799c0.344-0.248,0.635-0.467,1.104-0.689 l0.434,1.391l-0.666,0.061c-0.223,0.012-0.443,0.047-0.668,0.041l-0.672-0.031l-0.336-0.016l-0.336-0.057l-0.664-0.117 l-0.648-0.197c-0.217-0.059-0.424-0.15-0.625-0.252c-0.199-0.105-0.408-0.182-0.592-0.314c-0.186-0.123-0.381-0.238-0.557-0.373 l-0.512-0.424c-0.154-0.156-0.307-0.313-0.457-0.475c-0.137-0.164-0.264-0.342-0.398-0.516 c-0.246-0.355-0.467-0.725-0.641-1.113C128.471,203.338,128.322,202.938,128.238,202.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M148.703,296.74c0,0-14.66,5.195-7.688,23.393c0,0,1.754-19.238,25.027,2.291 c0,0,1.645-16.184-7.266-19.666C158.777,302.758,148.68,301.18,148.703,296.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M183.586,296.93c0,0,13.143,5.07,5.729,21.305c0,0-7.172-16.92-23.271,4.189 c0,0-2.174-17.822,7.404-19.588C173.447,302.836,183.563,301.369,183.586,296.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00818D"
    },
    d: "M228.725,237.777c-0.01,1.732-1.432,3.133-3.174,3.121l0,0c-1.738-0.008-3.15-1.424-3.139-3.156 l0,0c0.008-1.732,1.434-3.129,3.174-3.121l0,0C227.328,234.631,228.732,236.045,228.725,237.777L228.725,237.777z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464F5B"
    },
    d: "M200.508,228.6c0.023-4.432,3.654-8.002,8.107-7.979l0,0c4.453,0.025,8.049,3.633,8.021,8.064 l-0.098,18.053c-0.021,4.43-3.654,8-8.107,7.977l0,0c-4.451-0.025-8.045-3.635-8.02-8.063L200.508,228.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M210.225,229.084c3.465,4.326,3.91,9.334,2.887,14.621c-0.875,4.531-4.277,9.09-9.01,9.721 c1.25,0.803,2.732,1.281,4.33,1.289c4.453,0.023,8.086-3.547,8.107-7.977l0.098-18.053c0.027-4.432-3.568-8.039-8.021-8.064 c-3.482-0.016-6.453,2.164-7.598,5.232C204.432,225.451,207.977,226.273,210.225,229.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M203.363,228.613c0.004-0.461,0.381-0.83,0.846-0.826l0,0 c0.463,0,0.838,0.375,0.834,0.836l-0.107,20.389c-0.004,0.463-0.385,0.834-0.844,0.83l0,0c-0.467,0-0.84-0.377-0.836-0.838 L203.363,228.613z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B1C3"
    },
    d: "M215.57,225.41l-0.135,24.586c5.424-1.463,9.428-6.377,9.459-12.24 C224.926,231.891,220.977,226.938,215.57,225.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M221.057,242.434c-4.098-2.654-5.127-6.383-5.521-10.859l-0.1,18.422 c3.508-0.945,6.412-3.338,8.043-6.492C222.625,243.27,221.809,242.924,221.057,242.434z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C343F",
      strokeWidth: 3.0164,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M219.469,244.412c0,0,4.41,42.17-39.934,40.734"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232A33"
    },
    d: "M181.135,285.32c-0.014,2.031-1.676,3.67-3.717,3.658l-4.963-0.025 c-2.041-0.012-3.686-1.668-3.674-3.697l0,0c0.012-2.033,1.672-3.668,3.713-3.658l4.965,0.027 C179.498,281.637,181.145,283.289,181.135,285.32L181.135,285.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00818D"
    },
    d: "M101.998,237.096c-0.012,1.732,1.395,3.145,3.135,3.156l0,0c1.744,0.008,3.164-1.389,3.176-3.123 l0,0c0.008-1.732-1.398-3.146-3.141-3.154l0,0C103.426,233.963,102.006,235.361,101.998,237.096L101.998,237.096z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464F5B"
    },
    d: "M130.307,228.221c0.023-4.43-3.562-8.039-8.019-8.063l0,0c-4.455-0.023-8.086,3.545-8.109,7.977 l-0.096,18.051c-0.025,4.43,3.566,8.039,8.021,8.063l0,0c4.457,0.027,8.082-3.545,8.107-7.977L130.307,228.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M120.588,228.6c-3.512,4.289-4.01,9.295-3.047,14.592c0.826,4.539,4.182,9.133,8.904,9.816 c-1.256,0.789-2.742,1.252-4.342,1.24c-4.455-0.023-8.047-3.633-8.021-8.063l0.096-18.051c0.024-4.432,3.654-8,8.109-7.977 c3.48,0.02,6.428,2.232,7.543,5.313C126.424,225.033,122.867,225.816,120.588,228.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M127.453,228.205c0.004-0.463-0.373-0.834-0.836-0.838l0,0 c-0.465-0.002-0.842,0.367-0.846,0.83l-0.107,20.389c-0.004,0.461,0.371,0.838,0.836,0.838l0,0 c0.463,0.004,0.842-0.367,0.844-0.83L127.453,228.205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B1C3"
    },
    d: "M115.285,224.873l-0.133,24.582c-5.412-1.521-9.361-6.475-9.33-12.34 C105.854,231.25,109.855,226.338,115.285,224.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M109.615,241.834c4.119-2.609,5.191-6.326,5.637-10.799l-0.1,18.42 c-3.496-0.98-6.379-3.406-7.973-6.578C108.033,242.652,108.855,242.316,109.615,241.834z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.014,
    y: 193.838,
    style: {
      fill: "#3C3C3B"
    },
    width: 57.066,
    height: 68.143
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B233"
    },
    d: "M66.424,183.807H51.703c-2.771,0-5.016,2.246-5.016,5.016c0,2.771,2.244,5.016,5.016,5.016h14.721 c2.77,0,5.016-2.244,5.016-5.016C71.439,186.053,69.193,183.807,66.424,183.807z M64.422,191.518H53.703 c-2.018,0-3.652-1.326-3.652-2.965c0-1.637,1.635-2.965,3.652-2.965h10.719c2.018,0,3.654,1.328,3.654,2.965 C68.076,190.191,66.439,191.518,64.422,191.518z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.566,
    y: 196.588,
    style: {
      fill: "#FFFFFF"
    },
    width: 49.73,
    height: 62.029
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56B63"
    },
    d: "M49.531,209.395c0,2.873-2.328,5.203-5.201,5.203c-2.875,0-5.205-2.33-5.205-5.203 s2.33-5.203,5.205-5.203C47.203,204.191,49.531,206.521,49.531,209.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M49.531,222.502c0,2.873-2.328,5.203-5.201,5.203c-2.875,0-5.205-2.33-5.205-5.203 c0-2.873,2.33-5.203,5.205-5.203C47.203,217.299,49.531,219.629,49.531,222.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M49.531,235.609c0,2.873-2.328,5.203-5.201,5.203c-2.875,0-5.205-2.33-5.205-5.203 c0-2.875,2.33-5.203,5.205-5.203C47.203,230.406,49.531,232.734,49.531,235.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C6C6"
    },
    d: "M49.531,248.717c0,2.873-2.328,5.201-5.201,5.201c-2.875,0-5.205-2.328-5.205-5.201 c0-2.875,2.33-5.203,5.205-5.203C47.203,243.514,49.531,245.842,49.531,248.717z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M44,213.465c-0.016,0-0.033,0-0.049-0.002c-0.283-0.014-0.545-0.148-0.721-0.369l-2.848-3.559 c-0.34-0.426-0.271-1.047,0.154-1.387c0.424-0.34,1.045-0.271,1.385,0.154l2.154,2.691l6.367-6.49 c0.383-0.389,1.006-0.395,1.395-0.014c0.389,0.381,0.395,1.006,0.014,1.395l-7.148,7.283 C44.52,213.357,44.266,213.465,44,213.465z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 207.043,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 209.096,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.244
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 211.15,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 219.826,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.244
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 221.881,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 223.934,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.244
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 232.934,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 234.988,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 237.041,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 246.041,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 248.096,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.133,
    y: 250.148,
    style: {
      fill: "#DADADA"
    },
    width: 24.346,
    height: 1.242
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 41.703,
    y: 190.523,
    style: {
      fill: "#F9B233"
    },
    width: 33.459,
    height: 8.814
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D3953"
    },
    d: "M395.185,120.889c0,23.342-18.924,42.264-42.264,42.264c-23.342,0-42.264-18.922-42.264-42.264 c0-23.344,18.922-42.266,42.264-42.266C376.262,78.623,395.185,97.545,395.185,120.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.605,120.889c0,19.707-15.977,35.684-35.684,35.684c-19.707,0-35.684-15.977-35.684-35.684 c0-19.709,15.977-35.686,35.684-35.686C372.629,85.203,388.605,101.18,388.605,120.889z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.994,
    y: 83.381,
    style: {
      fill: "#0D3953"
    },
    width: 2.436,
    height: 8.123
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.994,
    y: 149.891,
    style: {
      fill: "#0D3953"
    },
    width: 2.436,
    height: 8.123
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.897,
    y: 119.48,
    style: {
      fill: "#0D3953"
    },
    width: 8.123,
    height: 2.434
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.404,
    y: 119.48,
    style: {
      fill: "#0D3953"
    },
    width: 8.123,
    height: 2.434
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.509,
    y: 140.15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 8.0751 307.9168)",
    style: {
      fill: "#0D3953"
    },
    width: 2.434,
    height: 8.123
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.48,
    y: 93.121,
    transform: "matrix(0.7067 -0.7075 0.7075 0.7067 27.6451 261.0543)",
    style: {
      fill: "#0D3953"
    },
    width: 2.435,
    height: 8.123
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.636,
    y: 142.994,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.6992 274.6628)",
    style: {
      fill: "#0D3953"
    },
    width: 8.123,
    height: 2.434
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.665,
    y: 95.965,
    transform: "matrix(0.7075 -0.7067 0.7067 0.7075 41.2207 293.9584)",
    style: {
      fill: "#0D3953"
    },
    width: 8.123,
    height: 2.435
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BE1622"
    },
    points: "352.211,120.889 352.211,120.934 355.057,120.934 352.211,94.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BE1622"
    },
    points: "354.967,119.514 354.934,119.48 352.922,121.492 373.291,137.838  "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.141,120.934c0,1.627-1.318,2.947-2.945,2.947c-1.627,0-2.945-1.32-2.945-2.947c0-1.625,1.318-2.943,2.945-2.943 C354.822,117.99,356.141,119.309,356.141,120.934z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E74645"
    },
    d: "M225.221,58.988c0-13.502-15.748-24.445-35.176-24.445s-35.176,10.943-35.176,24.445 c0,12.738,14.023,23.197,31.926,24.336l-1.344,0.109c0,0,5.85,8.781,18.582,13.846c0,0-6.305-4.338-2.826-15.109l0,0 C215.16,78.926,225.221,69.775,225.221,58.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M182.848,58.342c0,2.951-1.713,5.346-3.826,5.346c-2.111,0-3.824-2.395-3.824-5.346 c0-2.953,1.713-5.346,3.824-5.346C181.135,52.996,182.848,55.389,182.848,58.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M193.719,58.342c0,2.951-1.711,5.346-3.824,5.346s-3.826-2.395-3.826-5.346 c0-2.953,1.713-5.346,3.826-5.346S193.719,55.389,193.719,58.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.893,58.342c0,2.951-1.713,5.346-3.824,5.346c-2.113,0-3.826-2.395-3.826-5.346 c0-2.953,1.713-5.346,3.826-5.346C203.18,52.996,204.893,55.389,204.893,58.342z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D3953"
    },
    d: "M180.365,91.184c0-13.502,22.006-24.447,49.152-24.447c27.148,0,49.154,10.945,49.154,24.447 c0,12.738-19.596,23.195-44.613,24.336l1.881,0.107c0,0-8.176,8.783-25.969,13.848c0,0,8.811-4.338,3.951-15.111l0,0 C194.422,111.121,180.365,101.971,180.365,91.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M239.576,90.537c0,2.951,2.393,5.344,5.346,5.344c2.951,0,5.346-2.393,5.346-5.344 c0-2.953-2.395-5.346-5.346-5.346C241.969,85.191,239.576,87.584,239.576,90.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.385,90.537c0,2.951,2.393,5.344,5.346,5.344c2.951,0,5.346-2.393,5.346-5.344 c0-2.953-2.395-5.346-5.346-5.346C226.777,85.191,224.385,87.584,224.385,90.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M208.771,90.537c0,2.951,2.393,5.344,5.346,5.344c2.951,0,5.344-2.393,5.344-5.344 c0-2.953-2.393-5.346-5.344-5.346C211.164,85.191,208.771,87.584,208.771,90.537z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C3B"
    },
    d: "M364.848,206.717h-14.223c-2.676,0-4.846,2.17-4.846,4.846s2.17,4.846,4.846,4.846h14.223 c2.678,0,4.846-2.17,4.846-4.846S367.525,206.717,364.848,206.717z M362.916,214.166h-10.357c-1.949,0-3.529-1.281-3.529-2.863 s1.58-2.865,3.529-2.865h10.357c1.949,0,3.529,1.283,3.529,2.865S364.865,214.166,362.916,214.166z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 245.486,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 241.518,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 256.166,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 243.502,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 254.182,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.199
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 258.15,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 270.814,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 266.846,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 268.83,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C3B"
    },
    d: "M342.439,271.56c0.17,0.213,0.424,0.342,0.695,0.355c0.016,0.002,0.033,0.002,0.049,0.002 c0.256,0,0.5-0.104,0.68-0.285l6.906-7.039c0.367-0.375,0.361-0.978-0.014-1.348c-0.375-0.367-0.978-0.361-1.346,0.014 l-6.154,6.271l-2.08-2.602c-0.328-0.41-0.928-0.477-1.34-0.148c-0.41,0.328-0.477,0.928-0.148,1.34L342.439,271.56z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 233.135,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C3B"
    },
    d: "M342.439,258.897c0.17,0.211,0.424,0.342,0.695,0.355c0.018,0,0.033,0,0.049,0 c0.256,0,0.5-0.102,0.68-0.285l6.906-7.037c0.369-0.375,0.363-0.979-0.014-1.348c-0.375-0.367-0.977-0.361-1.346,0.014 l-6.154,6.271l-2.08-2.602c-0.328-0.41-0.928-0.477-1.34-0.148c-0.41,0.328-0.477,0.928-0.148,1.338L342.439,258.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C3B"
    },
    d: "M329.67,216.408v65.838h55.137v-65.838H329.67z M381.152,278.996h-48.049v-59.93h48.049V278.996z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C3B"
    },
    d: "M342.439,246.834c0.17,0.213,0.424,0.342,0.695,0.355c0.018,0.002,0.033,0.002,0.049,0.002 c0.256,0,0.5-0.104,0.68-0.285l6.906-7.039c0.369-0.375,0.363-0.979-0.014-1.348c-0.375-0.367-0.977-0.361-1.346,0.014 l-6.154,6.271l-2.08-2.602c-0.328-0.41-0.928-0.477-1.34-0.148c-0.41,0.328-0.477,0.928-0.148,1.338L342.439,246.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C3C3B"
    },
    d: "M342.439,235.014c0.17,0.213,0.424,0.342,0.695,0.355c0.018,0.002,0.033,0.002,0.049,0.002 c0.256,0,0.5-0.104,0.68-0.285l6.906-7.039c0.369-0.375,0.363-0.979-0.014-1.348c-0.375-0.367-0.977-0.361-1.346,0.014 l-6.154,6.271l-2.08-2.602c-0.328-0.41-0.928-0.477-1.34-0.148c-0.41,0.33-0.477,0.928-0.148,1.34L342.439,235.014z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 231.15,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.041,
    y: 229.166,
    style: {
      fill: "#3C3C3B"
    },
    width: 23.523,
    height: 1.201
  })), /*#__PURE__*/React.createElement("rect", {
    x: 340.963,
    y: 213.205,
    style: {
      fill: "#3C3C3B"
    },
    width: 32.328,
    height: 8.518
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#3C3C3B"
    },
    d: "M100.186,102.221c0-16.414-13.307-29.721-29.721-29.721 c-16.414,0-29.721,13.307-29.721,29.721c0,14.4,10.24,26.404,23.836,29.137c4.955,9.461,23.053,12.051,23.053,12.051 c-6.473-3.809-6.488-10.861-6.23-13.553C92.402,125.498,100.186,114.771,100.186,102.221z M72.576,119.326 c-0.82,0.822-1.818,1.232-2.992,1.232c-1.156,0-2.15-0.418-2.979-1.256c-0.83-0.836-1.244-1.826-1.244-2.967 c0-1.174,0.41-2.174,1.23-3.004c0.822-0.83,1.818-1.244,2.992-1.244c1.174,0,2.172,0.41,2.992,1.232 c0.82,0.82,1.232,1.826,1.232,3.016C73.809,117.508,73.396,118.506,72.576,119.326z M80.367,95.252 c-0.369,0.947-0.904,1.818-1.608,2.617c-0.83,0.938-2.105,1.971-3.826,3.098c-0.656,0.422-1.125,0.734-1.408,0.938 c-1.109,0.814-1.869,1.658-2.275,2.533c-0.406,0.877-0.609,2.082-0.609,3.615v0.305l-2.02-0.023 c-0.014-0.141-0.025-0.293-0.033-0.457c-0.01-0.166-0.012-0.412-0.012-0.74c0-0.922,0.072-1.783,0.223-2.58 c0.148-0.799,0.379-1.533,0.691-2.207c0.219-0.484,0.602-1.219,1.15-2.205c1.627-2.816,2.439-5.303,2.439-7.461 c0-1.879-0.449-3.371-1.348-4.482c-0.9-1.111-2.117-1.666-3.65-1.666c-1.064,0-2.057,0.289-2.979,0.869 c-0.924,0.578-1.385,1.086-1.385,1.523c0,0.205,0.25,0.4,0.75,0.588c0.5,0.188,0.861,0.344,1.08,0.469 c0.813,0.5,1.393,1.014,1.736,1.537c0.344,0.523,0.516,1.139,0.516,1.842c0,1.018-0.355,1.869-1.068,2.559 c-0.711,0.688-1.605,1.031-2.686,1.031c-1.174,0-2.139-0.441-2.898-1.324c-0.758-0.885-1.137-2.031-1.137-3.439 c0-2.471,0.973-4.473,2.92-6.006c1.947-1.533,4.533-2.301,7.756-2.301c3.082,0,5.557,0.775,7.426,2.324 c1.869,1.549,2.805,3.582,2.805,6.1C80.918,93.324,80.734,94.307,80.367,95.252z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar3);
export default __webpack_public_path__ + "static/media/car3.c3fdc39ac9fa0b04e648205484f42b2b.svg";
export { ForwardRef as ReactComponent };